import { FormattedMessage, useIntl } from 'react-intl';
import { Flex, Text } from '@theme-ui/components';

import Link from '@app/components/Link';

import ContentBlock from '../ContentBlock';
import { paymentMethods } from './paymentMethods';
import { image, link } from './styles';
import messages from './SupportedPaymentMethods.messages';

const SupportedPaymentMethods = () => {
  const intl = useIntl();

  return (
    <ContentBlock title={intl.formatMessage(messages.title)}>
      <Flex
        sx={{ flexWrap: 'wrap', justifyContent: ['center', 'space-between'] }}
      >
        {paymentMethods.map((payment, index) => (
          <img key={index} css={image} src={payment.src} alt={payment.alt} />
        ))}
      </Flex>

      <Text sx={{ display: 'block', fontSize: 0 }}>
        <FormattedMessage {...messages.note} />{' '}
        <Link
          css={link}
          to="/:language/shop-information/shipping-fees-payment/"
          data-testid="payments-info-link"
          target="_blank"
        >
          <FormattedMessage {...messages.infoLink} />
        </Link>
      </Text>
    </ContentBlock>
  );
};

export default SupportedPaymentMethods;
